import { apiClient } from '@/api/client'
import { SUPPORT_SESSIONS } from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types'

export interface VisibleSupportSession {
  id: string
  operatorName: string
  userEmail: string
  reason: string
  startedAt: string
  expiresAt: string
}

/** Trades the console's one-time code for the support session's cookie. */
export async function exchangeSupportCode(code: string): Promise<void> {
  await apiClient.post(SUPPORT_SESSIONS.EXCHANGE, { code })
}

export async function getVisibleSupportSessions(): Promise<VisibleSupportSession[]> {
  const { data } = await apiClient.get<ApiResponseWrapper<{ items: VisibleSupportSession[] }>>(
    SUPPORT_SESSIONS.VISIBLE,
  )
  return data.data.items
}

export async function endSupportSession(id: string): Promise<void> {
  await apiClient.post(SUPPORT_SESSIONS.end(id))
}
